module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("87MQR"))).then(() => parcelRequire('37nVf'));